/**
 * @fileoverview The student portal's Log practice (C6): one dialog, opened
 * from the sidebar, the top bar's plus, a "Practice this week" item on Home
 * and the Rehearsals page's practice log, drawn once here; and a counter that
 * moves after every log, so each of those reads its logs again. The web twin
 * of mobile/src/contexts/StudentPracticeContext.js.
 *
 * Outside the provider the hook returns an inert value: nothing opens and
 * nothing throws.
 */

import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { StudentLogPracticeDialog } from "@/components/StudentLogPracticeDialog";

const INERT = Object.freeze({ openLog: () => {}, version: 0 });

const StudentPracticeContext = createContext(INERT);

export function StudentPracticeProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [preset, setPreset] = useState(null);
  const [version, setVersion] = useState(0);

  /** Open the dialog, on an item or assignment when given one. */
  const openLog = useCallback((start = {}) => {
    setPreset(start || {});
    setOpen(true);
  }, []);
  const logged = useCallback(() => setVersion((n) => n + 1), []);

  const value = useMemo(() => ({ openLog, version }), [openLog, version]);

  return (
    <StudentPracticeContext.Provider value={value}>
      {children}
      <StudentLogPracticeDialog open={open} preset={preset} onOpenChange={setOpen} onLogged={logged} />
    </StudentPracticeContext.Provider>
  );
}

/** Open Log practice, and the count of logs made here so far. */
export const useStudentPractice = () => useContext(StudentPracticeContext);
